import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=4897bde4&scoped=true&lang=pug&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=4897bde4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4897bde4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/zx/@sdc/toolkit/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VStepper } from 'vuetify/lib'
import { VStepperHeader } from 'vuetify/lib'
import { VStepperStep } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardText,VContainer,VDivider,VFlex,VIcon,VLayout,VStepper,VStepperHeader,VStepperStep})
